<template>
  <Core></Core>
</template>

<script>
export default {
  name: 'App',
}
</script>